(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  const linklists = document.querySelectorAll('.site-footer-wrapper .footer__block__title.linklist');
  linklists.forEach((link) => {
    link.addEventListener('click', function() {
      let val = link.getAttribute('aria-expanded') == 'false' ? 'true' : 'false';
      link.setAttribute('aria-expanded', val);
      let tmenu_items = link.parentNode.querySelector('.tmenu_items');
      const keyframes = {
        height: ["0px", `${tmenu_items.scrollHeight}px`],
        visibility: ["hidden", "visible"]
      };
      tmenu_items?.animate(keyframes, {
        opacity: [0, 1],
        duration: 250,
        direction: val == 'true' ? "normal" : "reverse",
        easing: "cubic-bezier(0.75, 0, 0.175, 1)"
      });
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const linklists = document.querySelectorAll('.sliderule__wrapper.mobile_fold .sliderow.linklist');
  linklists.forEach((link) => {
	link.addEventListener('click', function() {
	  let val = link.getAttribute('aria-expanded') == 'false' ? 'true' : 'false';
	  let level = link.getAttribute('data-level');
	  link.setAttribute('aria-expanded', val);
	  let tmenu_items = link.parentNode.querySelector(`collapsible-content#${level}`);
	  const keyframes = {
		height: ["0px", `${tmenu_items.scrollHeight}px`],
		visibility: ["hidden", "visible"]
	  };
	  tmenu_items?.animate(keyframes, {
		opacity: [0, 1],
		duration: 750,
		direction: val == 'true' ? "normal" : "reverse",
		easing: "cubic-bezier(0.75, 0, 0.175, 1)"
	  });
	});
  })
  
  } catch(e) { console.error(e); }
})();
})();
